import styled from "styled-components";
import { availableLangs, useTranslate } from "../../contexts/translate";
import { useEffect, useState } from "react";

function getFlagFilename(lang: "en" | "fr") {
  switch (lang) {
    case "en":
      return "00-Flag-English-EN.png";
    case "fr":
      return "02-Flag-French-FR.png";
  }
}

const Container = styled.button`
  position: absolute;

  bottom: calc(5 * var(--u));
  right: calc(5 * var(--u));

  background: rgba(255, 255, 255, 0.2);
  border: none;
  box-shadow: none;
  border-radius: calc(2 * var(--u));
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(16 * var(--u));
  height: auto;
`;

const FlagContainer = styled.span`
  display: block;
  img {
    display: block;
    width: calc(6 * var(--u));
    aspect-ratio: 1;
  }
  span {
    display: block;
    text-align: center;
    color: white;
    font-size: calc(3 * var(--u));
    text-transform: uppercase;
    margin-top: calc(2 * var(--u));
  }

  margin: calc(2 * var(--u));
`;

export function LangButton() {
  const { lang, setLang } = useTranslate();
  const currentLang = lang || "en";

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open === true) {
      const handler = (e: Event) => {
        setOpen(false);
        e.preventDefault();
        e.stopPropagation();
      };
      setTimeout(() => document.body.addEventListener("click", handler), 0);
      return () => {
        document.body.removeEventListener("click", handler);
      };
    }
  }, [open]);

  return (
    <Container>
      {open &&
        availableLangs
          .filter((l) => l !== currentLang)
          .map((lang) => (
            <FlagContainer
              onClick={() => {
                setOpen(false);
                setLang(lang);
              }}
            >
              <img src={`/assets/ui/flags/${getFlagFilename(lang)}`} />
              <span>{lang}</span>
            </FlagContainer>
          ))}
      {/* White arrow here */}
      <FlagContainer
        onClick={() => {
          setOpen(!open);
        }}
      >
        <img src={`/assets/ui/flags/${getFlagFilename(currentLang)}`} />
        <span>{currentLang}</span>
      </FlagContainer>
    </Container>
  );
}
